import { render, staticRenderFns } from "./versionReview.vue?vue&type=template&id=422ebe11&scoped=true&"
import script from "./versionReview.vue?vue&type=script&lang=js&"
export * from "./versionReview.vue?vue&type=script&lang=js&"
import style0 from "./versionReview.vue?vue&type=style&index=0&id=422ebe11&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422ebe11",
  null
  
)

export default component.exports